export function setNestedValue<T extends object>(obj: T, path: string | string[], value: any): T {
    const pathParts = Array.isArray(path) ? path : path.split('.');

    // Create a deep copy of the object to ensure immutability
    const result = JSON.parse(JSON.stringify(obj)) as T;
    let current: any = result;

    for (let i = 0; i < pathParts.length - 1; i++) {
        const part = pathParts[i];
        const nextPart = pathParts[i + 1];

        // Check if current path part exists and is an object/array
        if (current[part] === undefined || current[part] === null) {
            // Create object or array based on next part (if next part is numeric, create array)
            current[part] = /^\d+$/.test(nextPart) ? [] : {};
        } else if (typeof current[part] !== 'object') {
            // If it exists but isn't an object, replace it with appropriate container
            current[part] = /^\d+$/.test(nextPart) ? [] : {};
        }

        current = current[part];
    }

    // Set the final value
    const lastPart = pathParts[pathParts.length - 1];
    current[lastPart] = value;

    return result;
}